export default "__VITE_ASSET__Bxd1mqZr__"